import { forwardRef } from "react";

import { keyframes, SvgIcon } from "@mui/material";
import { lighten, styled } from "@mui/material/styles";

const CustomizedComponent = styled(SvgIcon)(
  ({ theme, fillcolor = theme.palette.commonground.main }) => ({
    path: {
      transformBox: "fill-box",
      transformOrigin: "center",
      fill: fillcolor,
    },
    "#hex1": {
      animationName: `${slidein}`,
      animationDuration: `${animationDurationTime}`,
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      animationDelay: "0s",
      fill: lighten(fillcolor, 0.35),
    },

    "#hex2": {
      animationName: `${slidein}`,
      animationDuration: `${animationDurationTime}`,
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      animationDelay: "0.15s",
      fill: lighten(fillcolor, 0.55),
    },

    "#hex3": {
      animationName: `${slidein}`,
      animationDuration: `${animationDurationTime}`,
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      animationDelay: "0.3s",
    },
    "#hex4": {
      animationName: `${slidein}`,
      animationDuration: `${animationDurationTime}`,
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      animationDelay: "0.45s",
      fill: lighten(fillcolor, 0.15),
    },

    "#hex5": {
      animationName: `${slidein}`,
      animationDuration: `${animationDurationTime}`,
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      animationDelay: ".6s",
      fill: lighten(fillcolor, 0.25),
    },
  }),
);

const slidein = keyframes`
  0% {
    transform: scale(100%);
    opacity: 1;
  }
  25% {
    transform: scale(50%);
    opacity: .25;
  }
  30% {
    transform: scale(50%);
    opacity: .25;
  }
  50% {
    transform: scale(100%);
    opacity: 1;
  }
  75% {
    transform: scale(102%);
    opacity: .50;
  }
  80% {
    transform: scale(102%);
    opacity: .50;
  }
  100% {
    transform: scale(100%);
    opacity: 1;
  }
`;
const animationDurationTime = "2s";
const OmniSpinner = (props, ref) => {
  const { size, fillcolor } = props;
  return (
    <CustomizedComponent
      fillcolor={fillcolor}
      ref={ref}
      {...props}
      viewBox="0 0 448.28125 448.28125"
      id="omnisciaLogoSpinner"
      sx={{ height: `${size}px`, width: `${size}px` }}
    >
      <g id="shadow" transform="translate(96.514123,136.18519)" height="200px" width="200px">
        <path
          id="hex1"
          d="M 127.49272,67.8324 93.662637,9.19568 C 114.13845,-10.36516 144.20453,-9.85379 161.33256,9.24838 Z M 64.113807,-42.02112 27.027867,-106.30042 H 228.08061 l -37.09766,64.22266 c -30.96704,-21.04758 -95.841073,-18.54147 -126.869143,0.0566 z"
        />
        <path
          id="hex2"
          d="m 245.33549,-96.294568 -38.69532,67.070312 c 55.00691,55.96842 57.27206,180.301456 0.32813,234.535166 L 245.4722,271.97106 351.76713,87.955437 Z M 172.89017,29.273794 139.10697,87.830438 172.95658,146.432 c 7.48307,-39.53546 11.15101,-83.156129 -0.0664,-117.158206 z"
        />
        <path
          id="hex3"
          d="m 27.043494,281.72301 37.12695,-64.26953 c 27.69021,20.27713 93.243996,18.61992 126.496056,-0.11911 l 37.14848,64.38868 z m 66.46484,-115.05858 33.984386,-58.83009 33.66015,58.34181 c -19.97128,19.21308 -50.52944,18.88128 -67.644536,0.48828 z"
        />
        <path
          id="hex4"
          d="M 9.413617,272.28747 -91.287553,97.95739 h 97.72656 c 2.48275,42.1965 12.24364,79.95403 41.51954,107.59766 z m 72.26172,-125.10546 c -5.25191,-18.46652 -7.33753,-32.47278 -7.48635,-49.22462 h 35.919933 z"
        />
        <path
          id="hex5"
          d="M -89.408386,78.07067 11.109194,-95.943001 49.585754,-29.25355 C 24.005304,2.00271 9.425814,42.83668 8.158024,78.07067 Z m 165.34961,0 c 0.31677,-19.36442 2.82633,-35.55502 7.61133,-48.44922 l 27.953126,48.44922 z"
        />
      </g>
    </CustomizedComponent>
  );
};

export default forwardRef(OmniSpinner);
